import { insertContent } from '../core/dom.js';

/**
 * 汎用的なモーダル要素を作成する関数。
 * 作成されたモーダル要素はDOMには追加されないため、呼び出し側でappendChildなどを行う必要があります。
 *
 * @param {object} options - モーダルの設定オプション
 * @param {string} options.title - モーダルのタイトル
 * @param {string|HTMLElement} options.body - モーダルの本文 (HTML文字列またはDOM要素)
 * @param {boolean} [options.staticBackdrop=true] - 背景クリックで閉じないようにするか
 * @param {boolean} [options.centered=true] - モーダルを垂直方向にも中央寄せするか
 * @returns {HTMLElement|null} 作成されたモーダル要素、またはテンプレートが見つからなかった場合はnull
 */
export const createModalElement = (options) => {
    const defaultOptions = {
        templateId: 'base-modal-template',
        staticBackdrop: true,
        centered: true,
    // footerClasses: [],
    };
    const settings = { ...defaultOptions, ...options };
    const modalId = options.id || `modal-${Math.random().toString(36).substring(2, 9)}`;

    const template = document.getElementById(settings.templateId);
    if (!template) {
        console.error(`モーダルのベーステンプレート (ID: ${settings.templateId}) が見つかりません。`);
        return null;
    }

    const modalElement = document.createElement('div');
    modalElement.classList.add('modal', 'fade');
    modalElement.setAttribute('id', modalId);
    modalElement.setAttribute('tabindex', '-1');
    modalElement.setAttribute('role', 'dialog');
    modalElement.setAttribute('aria-hidden', 'true');
    if (settings.staticBackdrop) {
        modalElement.setAttribute('data-bs-backdrop', 'static');
    }

    const clonedContent = template.content.cloneNode(true);
    modalElement.appendChild(clonedContent);

    const modalDialog = modalElement.querySelector('.modal-dialog');
    if (modalDialog && settings.centered) {
        modalDialog.classList.add('modal-dialog-centered');
    }

    const titleElement = modalElement.querySelector('.modal-title');
    if (titleElement && 'title' in options) {
        insertContent(titleElement, settings.title);
    }

    const bodyElement = modalElement.querySelector('.modal-body');
    if (bodyElement && 'body' in options) {
        insertContent(bodyElement, settings.body);
    }

    // const footerElement = modalElement.querySelector('.modal-footer');
    // if (footerElement) {
    //   if ('footer' in options) {
    //     insertContent(footerElement, settings.footer);
    //   }
    //   if (Array.isArray(settings.footerClasses) && settings.footerClasses.length > 0) {
    //     footerElement.classList.add(...settings.footerClasses);
    //   }
    // }

    return modalElement;
};
